import axios from "axios";
import { useDispatch } from "react-redux";
import {
  handleDeleteButton,
  handleExpireState,
  handleLoadingSpinner,
} from "../../HandleSlice/HandleSlice";
import { handleDeleteButtonDisplayState } from "../../HandleSlice/HandleSlice";
import { Toastify } from "../../utils/function.utils";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { INTERNAL_PATHS } from "../../configs/routes.config";

const DeleteModal = (props) => {
  const {
    popupDisplay,
    setPopupDisplay,
    deleteEvent,
    fetchInputsData,
    location,
    setIsCheck,
    item,
  } = props;

  let secondDelete = 5;

  const [counterReverse, setCounterReverse] = useState(secondDelete);
  const timerRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const AsyncDeleteItem = () => {
    if (deleteEvent.getAttribute("key_value") === "remove") {
      const deleteId = deleteEvent.getAttribute("data_id");
      axios
        .delete(`/${location}/${deleteId}`)
        .then(() => fetchInputsData())
        .then(() => toast.dismiss())
        .then(() => setPopupDisplay("invisible opacity-0"))
        .then(() => setIsCheck([]))
        .then(() => dispatch(handleDeleteButtonDisplayState(false)))
        .then(() => dispatch(handleLoadingSpinner(false)))
        .then(() => setCounterReverse(secondDelete))
        .then(() => {
          Toastify("success", "اطلاعات با موفقیت حذف شد");
          dispatch(handleDeleteButton([]));
        })
        .catch((error) => {
          clearInterval(timerRef.current);
          setCounterReverse(secondDelete);
          dispatch(handleDeleteButton([]));
          if (error.response === undefined) {
            return;
          } else if (error.response.status === 404) {
            navigate(INTERNAL_PATHS.NOT_FOUND);
          } else if (error.response.status === 401) {
            dispatch(handleExpireState(false));
            localStorage.removeItem("Authorization");
          } else if (error.response.status === 500) {
            navigate("/serverEror");
          } else if (error.response.status === 405) {
            console.log("405");
          }
        });
    }
  };

  let deleteDataId = "";
  if (item) {
    deleteDataId =
      item.name ||
      item.company_name ||
      item.title ||
      item.user_name ||
      item.first_name;
  }

  const deleteHandler = () => {
    setPopupDisplay("invisible opacity-0");

    timerRef.current = setInterval(() => {
      setCounterReverse((lastItem) => lastItem - 1);
    }, 1000);

    Toastify(
      "customDelete",
      "آیا از حذف خود مطمئن هستید ؟",
      "ادامه",
      AsyncDeleteItem,
      timerRef.current,
      secondDelete,
      setCounterReverse,
      counterReverse,
    );
  };

  const cancelDeleteHandler = () => {
    setPopupDisplay("invisible opacity-0");
    dispatch(handleDeleteButton([]));
  };

  useEffect(() => {
    if (counterReverse === 0) {
      clearInterval(timerRef.current);
      AsyncDeleteItem();
    }
  }, [counterReverse, AsyncDeleteItem]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 z-[99999] w-[100%] h-[100vh] backdrop-blur-sm bg-black/20 ${popupDisplay} transition-all delay-100`}
        onClick={() => {
          setPopupDisplay("invisible opacity-0");
          dispatch(handleDeleteButton([]));
        }}
      ></div>

      <div
        className={`fixed z-[999999] transition-all delay-100 right-[calc(50%-35%)] sm:right-[calc(50%-25%)] md:right-[calc(50%-20%)]  xl:right-[calc(50%-15%)] top-[calc(50vh-180px)]  bg-white w-[70%] sm:w-[50%] md:w-[40%] xl:w-[30%] rounded-md ${popupDisplay} `}
      >
        <div className="flex justify-between py-[15px] px-[20px]">
          <h4 className="text-[16px] font-semibold ">هشدار !</h4>
          <button
            className="fa fa-times text-[#4a526f]"
            onClick={() => {
              setPopupDisplay("invisible opacity-0");
            }}
          ></button>
        </div>
        <div className="w-[100%] border-t border-b border-[#e8e8f7] p-[25px] text-[#1d212f]">
          <p className="text-[16px] font-bold text-center leading-7">
            <span>
              آیا از حذف &nbsp;
              <span>{deleteDataId} ،</span>
              مطمئن هستید؟
            </span>
          </p>
        </div>
        <div className="flex justify-end p-5 gap-2">
          <button
            className="bg-confirm_button_background text-confirm_button_text border border-confirm_button_border w-[54px] h-[38px] rounded-[3px] hover:bg-confirm_button_background_hover"
            onClick={deleteHandler}
          >
            بله
          </button>

          <button
            className="bg-cancel_button_background text-cancel_button_text w-[54px] h-[38px] rounded-[3px] border border-cancel_button_border hover:bg-cancel_button_background_hover"
            onClick={cancelDeleteHandler}
          >
            خیر
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
